export const ARCHIVAL_STATE_LIST = [
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'CANCELED', label: 'Cancelled' },
  { value: 'TERMINATED', label: 'Terminated' },
  { value: 'CONTINUED_AS_NEW', label: 'Continued As New' },
  { value: 'TIMED_OUT', label: 'Timed Out' },
];

export const DEFAULT_RANGE = 'last-24-hours';

export const LOADING_MESSAGE_DELAY = 3000;



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/constants.js